import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { JobToSchedule, ScheduleBlock, SchedulerFittersResponse } from '../models/schedule.models';

/** Workshop scheduler API (logixi-be workshop-schedule module). */
@Injectable({
  providedIn: 'root'
})
export class ScheduleService {
  private readonly endpoint = environment.api.endpoint + 'schedule-block';

  constructor(private http: HttpClient) { }

  blocks(from: string, to: string): Observable<ScheduleBlock[]> {
    return this.http.get<ScheduleBlock[]>(`${this.endpoint}?from=${from}&to=${to}`);
  }

  fitters(from: string, to: string): Observable<SchedulerFittersResponse> {
    return this.http.get<SchedulerFittersResponse>(`${this.endpoint}/fitters?from=${from}&to=${to}`);
  }

  toSchedule(search: string = ''): Observable<JobToSchedule[]> {
    return this.http.get<JobToSchedule[]>(`${this.endpoint}/to-schedule?search=${encodeURIComponent(search)}`);
  }

  create(job: JobToSchedule, fitterId: number, startAt: string, endAt: string): Observable<ScheduleBlock> {
    return this.http.post<ScheduleBlock>(this.endpoint, {
      fitterId, jobType: job.jobType, startAt, endAt,
      workshopDefectId: job.jobType === 'defect' ? job.id : undefined,
      vehicleInspectionId: job.jobType === 'inspection' ? job.id : undefined,
    });
  }

  move(id: number, fitterId: number, startAt: string, endAt: string): Observable<ScheduleBlock> {
    return this.http.patch<ScheduleBlock>(`${this.endpoint}/${id}`, { fitterId, startAt, endAt });
  }

  saveNotes(id: number, notes: string): Observable<ScheduleBlock> {
    return this.http.patch<ScheduleBlock>(`${this.endpoint}/${id}`, { notes });
  }

  complete(id: number, actualHours: number, notes: string): Observable<ScheduleBlock> {
    return this.http.post<ScheduleBlock>(`${this.endpoint}/${id}/complete`, { actualHours, notes });
  }

  /** `plannedOnly` (undo/redo): the server refuses if the job has been completed since. */
  remove(id: number, plannedOnly = false): Observable<unknown> {
    return this.http.delete(`${this.endpoint}/${id}${plannedOnly ? '?planned=1' : ''}`);
  }
}
